import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";
import { displayValue, hasAnyValue } from "../../../../../../../utils/commonFunctions/displayValue";
import MeasurementTable from "./MeasurementTable";
import "./ScanDetailsSections.css";

const ScanSnapshot = ({ legScan }: ILegScanProps) => {
	const snapshotRows = [
		{ label: "Foot Length (mm)", left: legScan.left_length, right: legScan.right_length },
		{ label: "Foot Width (mm)", left: legScan.left_width, right: legScan.right_width },
		{ label: "Shoe Size (UK)", left: legScan.left_shoe_size_uk, right: legScan.right_shoe_size_uk },
		{ label: "Shoe Size (EU)", left: legScan.left_shoe_size_eu, right: legScan.right_shoe_size_eu }
	];

	const showArchIndex = hasAnyValue([legScan.left_ahi, legScan.right_ahi]);

	return (
		<div className="measurement-tables-row">
			<MeasurementTable title="Snapshot" rows={snapshotRows} />
			{showArchIndex ? (
				<div className="measurement-table-block">
					<h4 className="measurement-table-title">Arch Index</h4>
					<div className="scan-header-info">
						<div className="scan-header-info-item">
							<p className="scan-header-info-label">Left</p>
							<p className="scan-header-info-value">
								{displayValue(legScan.left_ahi)}
								{legScan.arch_type_left ? (
									<span className="arch-type-chip">{legScan.arch_type_left}</span>
								) : null}
							</p>
						</div>
						<div className="scan-header-info-item">
							<p className="scan-header-info-label">Right</p>
							<p className="scan-header-info-value">
								{displayValue(legScan.right_ahi)}
								{legScan.arch_type_right ? (
									<span className="arch-type-chip">{legScan.arch_type_right}</span>
								) : null}
							</p>
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default ScanSnapshot;
